import { FloatingFormItem, InputDate } from '@/components/_common';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { UploadArchiveResult } from '@/core/domain/archive/Archive/Archive.types';
import { useRemoveCertificateAgreement } from '@/core/domain/enterprise/AgreementCertificate/AgreementCertificate.hooks';
import {
  BankAccountSettings,
  BankAccountSettingsFormValues,
} from '@/core/domain/enterprise/BankAccountsSettings/BankAccountsSettings.types';
import {
  Button,
  Col,
  Form,
  FormInstance,
  Input,
  Modal,
  Row,
  Upload,
  UploadFile,
  message,
} from 'antd';

interface Props {
  form: FormInstance<BankAccountSettingsFormValues>;
  bankAccountSettings?: BankAccountSettings;
  bankAccountId?: number;
}

export default function ConfigBankSlipCertificateForm({
  form,
  bankAccountSettings,
  bankAccountId,
}: Props) {
  const removeCertificate = useRemoveCertificateAgreement();

  function normalizeFiles(e: {
    file: UploadFile<UploadArchiveResult>;
    fileList: UploadFile<UploadArchiveResult>[];
  }) {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  }

  function handleRemoveCertificate() {
    if (bankAccountId) {
      Modal.confirm({
        title: 'Remoção de certificado',
        content: 'Se remover o certificado o processo não poderá ser revertido',
        onOk: async () => {
          try {
            await removeCertificate.mutateAsync(bankAccountId);
          } catch {}
        },
      });
    }
  }

  return (
    <Form form={form} name="bankAccountConfigBullet">
      <Row gutter={[12, 12]}>
        <Col span={!!bankAccountSettings?.certificate ? 12 : 24}>
          <Form.Item
            style={{ margin: 0 }}
            name={['certificate', 'certificateFile']}
            getValueFromEvent={normalizeFiles}
            valuePropName="fileList"
          >
            <Upload
              disabled={!!bankAccountSettings?.certificate}
              accept=".pfx"
              type="select"
              name="file"
              maxCount={1}
              beforeUpload={(file) => {
                const isPfx = file.type === 'application/x-pkcs12';

                if (!isPfx) {
                  message.error(`${file.name} não é um arquivo ".pfx"`);
                } else {
                  return false;
                }

                return isPfx || Upload.LIST_IGNORE;
              }}
            >
              <Button disabled={!!bankAccountSettings?.certificate}>
                Selecionar arquivo do certificado
              </Button>
            </Upload>
          </Form.Item>
        </Col>

        {!!bankAccountSettings?.certificate && (
          <Col span={12}>
            <SpaceForButton justifyContent="flex-end">
              <Button block danger onClick={handleRemoveCertificate}>
                Apagar certificado
              </Button>
            </SpaceForButton>
          </Col>
        )}

        {!!bankAccountSettings?.certificate?.expirationDate && (
          <Col span={24} md={12} lg={4} xxl={5}>
            <FloatingFormItem
              label="Data de expiração"
              name={['certificate', 'certificateExpirationDate']}
            >
              <InputDate
                disabled={!!bankAccountSettings?.certificate?.expirationDate}
              />
            </FloatingFormItem>
          </Col>
        )}

        <Col span={24} md={12} lg={6} xxl={8}>
          <FloatingFormItem
            label="Senha do certificado"
            name={['certificate', 'certificatePassword']}
          >
            <Input
              maxLength={20}
              disabled={!!bankAccountSettings?.certificate}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={6} xxl={8}>
          <FloatingFormItem
            label="Alias certificado"
            name={['certificate', 'certificateAlias']}
          >
            <Input
              maxLength={250}
              disabled={!!bankAccountSettings?.certificate}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={6} xxl={8}>
          <FloatingFormItem
            label="E-mail certificado"
            name={['certificate', 'certificateEmail']}
            rules={[{ type: 'email', message: 'E-mail inválido' }]}
          >
            <Input disabled={!!bankAccountSettings?.certificate} />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}
